// @ts-check
import { api } from "../client.js";

/** Endpoints do painel Master. */
export const masterApi = {
  // ------------------------------------------------------------- visão geral
  stats: () => api.get("/master/stats"),
  usage: () => api.get("/master/usage"),
  onboarding: () => api.get("/master/onboarding"),

  // ---------------------------------------------------------------- clientes
  /** @param {{ search?: string, status?: string }} [filtros] */
  clients: (filtros) => api.get("/master/clients", filtros),

  /** @param {string} id */
  client: (id) => api.get(`/master/clients/${id}`),

  /** @param {object} dados */
  createClient: (dados) => api.post("/master/clients", dados),

  /** @param {string} id @param {object} patch */
  updateClient: (id, patch) => api.patch(`/master/clients/${id}`, patch),

  /** @param {string} id */
  deleteClient: (id) => api.delete(`/master/clients/${id}`),

  // -------------------------------------------------------- acesso ao cliente
  /** @param {string} clinicId */
  startImpersonation: (clinicId) => api.post(`/master/clients/${clinicId}/impersonate`),
  stopImpersonation: () => api.post("/master/impersonate/stop"),

  // ------------------------------------------------------------------ planos
  plans: () => api.get("/master/plans"),
  /** @param {object} dados */
  savePlan: (dados) => api.put("/master/plans", dados),

  // --------------------------------------------------------------- cobranças
  /** @param {{ status?: string, clinicId?: string }} [filtros] */
  invoices: (filtros) => api.get("/master/invoices", filtros),
  /** @param {object} dados */
  createInvoice: (dados) => api.post("/master/invoices", dados),
  /** @param {string} id @param {object} patch */
  updateInvoice: (id, patch) => api.patch(`/master/invoices/${id}`, patch),

  // ----------------------------------------------------------------- suporte
  /** @param {{ status?: string }} [filtros] */
  tickets: (filtros) => api.get("/master/tickets", filtros),
  /** @param {object} dados */
  createTicket: (dados) => api.post("/master/tickets", dados),
  /** @param {string} id @param {object} patch */
  updateTicket: (id, patch) => api.patch(`/master/tickets/${id}`, patch),

  // --------------------------------------------------------- equipe da plataforma
  users: {
    /** @param {{ search?: string, role?: string }} [filtros] */
    list: (filtros) => api.get("/master/users", filtros),
    /** @param {object} dados */
    create: (dados) => api.post("/master/users", dados),
    /** @param {string} id @param {object} patch */
    update: (id, patch) => api.patch(`/master/users/${id}`, patch),
    /** @param {string} id @param {{ password?: string }} [dados] */
    resetPassword: (id, dados = {}) => api.post(`/master/users/${id}/reset-password`, dados),
    /** @param {string} id */
    remove: (id) => api.delete(`/master/users/${id}`),
  },

  // --------------------------------------------------------------- auditoria
  /** @param {{ category?: string, search?: string, limit?: number }} [filtros] */
  audit: (filtros) => api.get("/master/audit", filtros),
};
